import { OnboardingModulesTypes } from '@frontend/api-onboarding-modules';
import { OnboardingTasksV2 } from '@frontend/api-onboarding-tasks';
import { ModuleTaskInfo } from './types';

export const TRAINING_LINK = 'https://trainingcamp.weavehelp.com/';
export const ONBOARDING_DASHBOARD_PATH = '/home/onboarding';
export const DASHBOARD_PATH = '/home/dashboard';
export const ONBOARDING_DASHBOARD_FF = 'onboarding:dashboard-v2';

export const SchedulingTypeMetaDataKeys = [
  OnboardingTasksV2.Types.MetaDataKeys.PHONES_SHIPPED_DATE,
  OnboardingTasksV2.Types.MetaDataKeys.SCHEDULE_CALL_DATE,
  OnboardingTasksV2.Types.MetaDataKeys.PORT_DATES,
];

export const AppointmentDateFormat = {
  DEFAULT: 'MMM D, YYYY @ h:mm A',
  ALTERNATE: 'MMM D, YYYY • h:mm A',
};

export const ModuleTaskInfoMap: Record<number, ModuleTaskInfo> = {
  [OnboardingModulesTypes.TaskIds.EINSetup]: {
    settingsRedirectConfig: {
      to: '/organization/business-verification',
    },
  },
  [OnboardingModulesTypes.TaskIds.Register10DLC]: {
    settingsRedirectConfig: {
      to: '/organization/messaging-compliance-registration',
    },
  },
  [OnboardingModulesTypes.TaskIds.UserInviteSetup]: {
    settingsRedirectConfig: {
      to: '/organization/users',
      search: {
        invite: 'true',
      },
    },
  },
  [OnboardingModulesTypes.TaskIds.PaymentsStripeSetup]: {
    settingsRedirectConfig: {
      to: '/payments/account-info',
    },
  },
  [OnboardingModulesTypes.TaskIds.PortingInformation]: {
    settingsRedirectConfig: {
      to: '/organization/phone-numbers',
    },
  },
  [OnboardingModulesTypes.TaskIds.ReviewsSetup]: {
    settingsRedirectConfig: {
      to: '/reviews',
    },
  },
  [OnboardingModulesTypes.TaskIds.MessagingAutoReminder]: {
    settingsRedirectConfig: {
      to: '/messaging',
    },
  },
  [OnboardingModulesTypes.TaskIds.E911]: {
    settingsRedirectConfig: {
      to: '/phone/e911',
    },
  },
};
